import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { Pagination } from '../models/pagination.model';
import { AppConfig } from '../helpers/app.config';
import { Process, ProcessCreate, ProcessSearch, ProcessEdit, ProcessDeleted } from '../models/process.model';
import { fromProcessSearch } from '../reducers/process-search.reducer';

@Injectable({
  providedIn: 'root'
})
export class ProcessService {

  constructor(private store: Store, private httpClient: HttpClient) { }

  search(process: ProcessSearch, page: number): Observable<Pagination<Process>> {
    return this.httpClient.get<Pagination<Process>>(AppConfig.settings.API + '/processes?origin=ct',
      { params: { ...process, page } as any }
    );
  }

  create(process: ProcessCreate): Observable<Process> {
    return this.httpClient.post<Process>(AppConfig.settings.API + '/processes?origin=ct', process);
  }

  edit(process: ProcessEdit): Observable<Process> {
    return this.httpClient.put<Process>(AppConfig.settings.API + '/processes?origin=ct', process);
  }

  delete(process: ProcessDeleted): Observable<boolean> {
    return this.httpClient.delete<any>(AppConfig.settings.API + '/processes?origin=ct',
      { params: { ...process } as any }
    );
  }

}
